import { render } from "./UploadMedia.vue?vue&type=template&id=49a26c63&scoped=true"
import script from "./UploadMedia.vue?vue&type=script&lang=js"
export * from "./UploadMedia.vue?vue&type=script&lang=js"

import "./UploadMedia.vue?vue&type=style&index=0&id=49a26c63&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a26c63"]])

export default __exports__